const Mn = require("backbone.marionette");
const OpenUriTemplate = require("data/ui/template/content/open-uri.hbs");
const ModalView = require('common/ui/view/modal/index');
const URLCopyView = require('data/ui/view/modal/url-copy');
const URLCopyFooterView = require('data/ui/view/modal/url-copy-footer');
const StorageAPI = require('data/infra/api/storage/index');
const i18n = require('i18next');

module.exports = Mn.View.extend({
    tagName: 'span',
    template: OpenUriTemplate,
    templateContext: function() {
        const version = this.getOption('version');
        const project = this.getOption('project');

        const uri = version.getDataSource().getURI();
        const storageObjectId = version.getDataSource().getStorageObjectId();
        const downloadURI = (project && storageObjectId) ?
            StorageAPI.getDownloadURL(project.id, storageObjectId) : null;

        return {
            downloadURI,
            uri,
            isHTTP: uri ? uri.match(/^http/) : false,
            isEmpty: version.isEmpty()
        };
    },
    ui: {
        'downloadContentButton': '.content-download-button',
        'openlinkContentButton': '.content-openlink-button',
        'copylinkContentButton': '.content-copylink-button'
    },
    events: {
        'click @ui.downloadContentButton': 'downloadContent',
        'click @ui.openlinkContentButton': 'openlinkContent',
        'click @ui.copylinkContentButton': 'showURLCopy'
    },
    downloadContent: function() {
        // ダウンロードイベントをトラッキングするならば、ここに仕込む
    },
    openlinkContent: function() {
        // リンクを開いたイベントをトラッキングするならば、ここに仕込む
    },
    showURLCopy: function() {
        const version = this.getOption('version');

        const modal = new ModalView({
            model: this.model,
            title: i18n.t('data:content.copyURL.title'),
            bodyView: new URLCopyView({
                name: version.getName(),
                url: version.getDataSource().getURI()
            }),
            footerView: new URLCopyFooterView(),
            onChildviewCopy: function() {
                this.disableButtons();
                this.getOption('bodyView').copyURL()
                    .then(() => {
                        this.getOption('footerView').showTooltip();
                        this.enableButtons();
                    })
            }
        });
        modal.show();
    }
});



// WEBPACK FOOTER //
// ./data/ui/view/content/open-uri.js